import { createContext, useCallback, useContext, useState, ReactNode, useMemo } from 'react'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

interface CurrentSlideContextValue {
  currentSlideIndex: number
  setCurrentSlideIndex: (index: number, platform: ExternalIntegrationEnum) => void
}

const CurrentSlideContext = createContext<CurrentSlideContextValue | null>(null)

export const CurrentSlideProvider = ({
  children,
  activePlatform,
}: {
  children: ReactNode
  activePlatform?: ExternalIntegrationEnum
}) => {
  const [currentSlideIndex, setCurrentSlideIndexState] = useState(0)

  const setCurrentSlideIndex = useCallback(
    (index: number, platform: ExternalIntegrationEnum) => {
      if (activePlatform && platform !== activePlatform) return
      setCurrentSlideIndexState(index)
    },
    [activePlatform],
  )

  const value = useMemo(() => ({ currentSlideIndex, setCurrentSlideIndex }), [currentSlideIndex, setCurrentSlideIndex])

  return <CurrentSlideContext.Provider value={value}>{children}</CurrentSlideContext.Provider>
}

const defaultValue: CurrentSlideContextValue = {
  currentSlideIndex: 0,
  setCurrentSlideIndex: () => {},
}

export const useCurrentSlide = () => {
  return useContext(CurrentSlideContext) ?? defaultValue
}

export const useOptionalCurrentSlide = () => {
  return useContext(CurrentSlideContext)
}
